import Result, { EmptyResult } from '@package/services/src/Result';

import {
  AddMissingItemRequest,
  AddProductRequest,
  AddProductServiceRequest,
  DeleteProductRequest,
  DeleteProductServiceRequest,
  GetProductAddonsRequest,
  GetServiceInfoRequest,
  GetShoppingCardRequest,
  GetSuggestedProductsRequest,
  ProductQuantityRequest,
} from './interactorTypes';
import { CartService } from './services';
import { ShoppingCard, ServiceInfo, ProductAddons, ProductAddonElement } from './types';

export default class CartInteractor {
  public constructor(private readonly cartService: CartService) {}

  public getShoppingCard(request?: GetShoppingCardRequest): Promise<Result<ShoppingCard | undefined>> {
    return this.cartService.getShoppingCard(request);
  }

  public synchronizationCookie(): Promise<EmptyResult> {
    return this.cartService.synchronizationCookie();
  }

  public getCartShareLink(): Promise<Result<string | undefined>> {
    return this.cartService.getCartShareLink();
  }

  public getServiceInfo(request: GetServiceInfoRequest): Promise<Result<ServiceInfo | undefined>> {
    return this.cartService.getServiceInfo(request);
  }

  public addProduct(request: Array<AddProductRequest>): Promise<EmptyResult> {
    return this.cartService.addProduct(request);
  }

  public getProductAddons(request: GetProductAddonsRequest): Promise<Result<ProductAddons | undefined>> {
    return this.cartService.getProductAddons(request);
  }

  public getSuggestedProducts(
    request: GetSuggestedProductsRequest,
  ): Promise<Result<Array<ProductAddonElement> | undefined>> {
    return this.cartService.getSuggestedProducts(request);
  }

  public addProductService(request: AddProductServiceRequest): Promise<EmptyResult> {
    return this.cartService.addProductService(request);
  }

  public addMissingItem(request: AddMissingItemRequest): Promise<EmptyResult> {
    return this.cartService.addMissingItem(request);
  }

  public updateProductQuantity(request: ProductQuantityRequest): Promise<EmptyResult> {
    return this.cartService.updateProductQuantity(request);
  }

  public deleteProduct(request: DeleteProductRequest): Promise<EmptyResult> {
    return this.cartService.deleteProduct(request);
  }

  public deleteProductService(request: DeleteProductServiceRequest): Promise<EmptyResult> {
    return this.cartService.deleteProductService(request);
  }

  public saveToWishlist(): Promise<EmptyResult> {
    return this.cartService.saveToWishlist();
  }

  public clearShippingOptions(): Promise<EmptyResult> {
    return this.cartService.clearShippingOptions();
  }
}
